export default __webpack_public_path__ + "static/media/meeting.b8e52de7.png";